module.exports = __webpack_public_path__ + "assets/employment-dashboard-bulk-upload-template.9e6afc8c.xlsx";